import Config from 'services/config/config';
import { SHOW_HIDE_TOAST } from 'services/redux/sales/appNotifications/type';
import { store } from 'services/redux/store';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  CAMP_LIST,
  POC_LIST_DROPDOWN,
  MEETING_BY_ID,
  VIEW_MOM,
  VENDOR_LIST,
  GET_PRECAMP_QUES,
  POST_PRECAMP_QUES,
  ADD_POST_CAMP,
  VIEW_VENDOR,
  CAMP_APPROVAL,
  INFRA_ID,
  CARNIVAL_LIST,
  CARNIVAL_DETAIL,
  CARNIVAL_DATA,
  NORMAL_BOARDING_LISTING, NORMAL_ONBAORDING_DATA,
  PROJECT_ONBOARDING_LISTING,
  HELPDESK_LIST,
  HELPDESK_DETAIL, HELPDESK_DATA,CLIENT_ADDRESS_DETAILS,BUSINESS_ADDRESS_DETAILS,
} from './type';

export const getCampList = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.conductCampListing}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CAMP_LIST, payload: data.response.data });
    return data.response.data;
  }
};

export const getApprovalCampList = (page = 1, queryObj = null) => async (
  dispatch
) => {
  let filterQuery = '';
  if (queryObj !== null) {
    filterQuery = `?status=${queryObj.status}&date=${queryObj.date}&site_no=${queryObj.site_no}`;
  }

  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.campApprovalList}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CAMP_APPROVAL, payload: data.response.data });
    return data.response.data;
  }
};

export const campApproval = (id) => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.campApprove}?camp_id=${id}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const updateCampStatus = (requestData) => async () => {
  const res = await callWebService(
    callTypes.put,
    requestData,
    `${Config.brandActivation.updateCampStatus}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const campReject = (id) => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.campReject}?camp_id=${id}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const getPocList = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.sitePocList}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_LIST_DROPDOWN, payload: data.response.data });
    return data.response.data;
  }
};

export const createCamp = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.createCamp
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const updateMeeting = (requestData) => async () => {
  const res = await callWebService(
    callTypes.put,
    requestData,
    Config.brandActivation.updateMeeting
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const getMeetingById = (meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.viewCamp}?camp_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEETING_BY_ID, payload: data.response.data });
    return data.response.data;
  }
};

export const cancelMeeting = (meetingId) => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.cancelMeeting}?meeting_id=${meetingId}`
  );
  if (res?.data?.response?.status === false) {
    store.dispatch({
      type: SHOW_HIDE_TOAST,
      payload: { isToast: true, toastMessage: res?.data?.message },
    });
  }
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const completeMeeting = (meetingId) => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.completeMeeting}?meeting_id=${meetingId}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const createMom = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.campMom
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const getMomBymeetingId = (meetingId) => async (dispatch) => {
  dispatch({ type: VIEW_MOM, payload: null });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.campMomView}?camp_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: VIEW_MOM, payload: data.response.data });
    return data.response.data;
  }
};

export const getVendorList = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getVendor}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: VENDOR_LIST, payload: data.response.data });
    return data.response.data;
  }
};

export const postVendor = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.postVendor
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const getPreCampQues = (id) => async (dispatch) => {
  dispatch({ type: GET_PRECAMP_QUES, payload: null });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.fetchPreCampQues}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_PRECAMP_QUES, payload: data.response.data });
    return true;
  }
};

export const postPreCampQues = (data) => async (dispatch) => {
  dispatch({ type: POST_PRECAMP_QUES, payload: null });
  const res = await callWebService(
    callTypes.post,
    data,
    Config.brandActivation.postPreCampAns
  );
  if (res) {
    const { data } = res;
    if (data?.response?.status) {
      dispatch({ type: POST_PRECAMP_QUES, payload: data.response.message });
      return true;
    }
  }
};

export const addPostCamp = (data) => async (dispatch) => {
  dispatch({ type: ADD_POST_CAMP, payload: null });
  const res = await callWebService(
    callTypes.post,
    data,
    Config.brandActivation.postCampTraining
  );
  if (res) {
    const { data } = res;
    if (data.response.status) {
      dispatch({ type: ADD_POST_CAMP, payload: data.response.message });
      return true;
    }
  }
};

export const viewVendorDetails = (id, campId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.viewVendor}?vendor_id=${id}&camp_id=${campId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: VIEW_VENDOR, payload: data.response.data });
    return data.response.data;
  }
};

export const getLeadInfraId = (infraId, siteId = null) => async (dispatch) => {
  const url = `${Config.brandActivation.getInfraId}?infra_id=${infraId}${
    siteId ? `&site_id=${siteId}` : ''
  }`;
  const res = await callWebService(callTypes.get, '', url);
  if (res) {
    const { data } = res;
    dispatch({ type: INFRA_ID, payload: data.response.data });
    return data.response.data;
  }
};

export const saveCarnival = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.saveCarnival
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};
 
export const getClientAddressDetails = (client_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getClientAddressDetails}?client_id=${client_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CLIENT_ADDRESS_DETAILS, payload: data.response.data });
    return data.response.data;
  }
};

export const getBusinessAddressDetails = (lead_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getBusinessAddressDetails}?lead_id=${lead_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: BUSINESS_ADDRESS_DETAILS, payload: data.response.data });
    return data.response.data;
  }
};

export const saveNormalCarnival = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.saveNormalCarnival
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const getNormalOnBoardingListing = (filterData = null, page = 1) => async (dispatch) => {

  let filterQuery = '';
  if (filterData !== null) {
    filterQuery = `?page=${page}`;
    if (filterData?.status) {
      filterQuery = filterQuery + `&status=${filterData.status}`;
    }
    if (filterData?.project_id) {
      filterQuery = filterQuery + `&project_id=${filterData.project_id}`;
    }
    if (filterData?.project_name) {
      filterQuery = filterQuery + `&project_name=${filterData.project_name}`;
    }

  } else {
    filterQuery = `?page=${page}`;
  }
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.normalCarnivalListing}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: NORMAL_BOARDING_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

export const getCarnivalList = (filterData = null, page = 1) => async (dispatch) => {
  
  let filterQuery = '';
  if (filterData !== null) {
    filterQuery = `?page=${page}`;
    if (filterData?.status) {
      filterQuery = filterQuery + `&status=${filterData.status}`;
    }
    if (filterData?.project_id) {
      filterQuery = filterQuery + `&project_id=${filterData.project_id}`;
    }
    if (filterData?.project_name) {
      filterQuery = filterQuery + `&project_name=${filterData.project_name}`;
    }
    if (filterData?.fromDate) {
      filterQuery = filterQuery + `&from_date=${filterData.fromDate}`;
    }
    if (filterData?.toDate) {
      filterQuery = filterQuery + `&to_date=${filterData.toDate}`;
    }
    if (filterData?.site_id) {
      filterQuery = filterQuery + `&site_id=${filterData.site_id}`;
    }

  } else {
    filterQuery = `?page=${page}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.carnivalListing}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CARNIVAL_LIST, payload: data.response.data });
    return data.response.data;
  }
};

export const getCarnivalDetail = (meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.viewCarnival}?carnival_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CARNIVAL_DETAIL, payload: data.response.data });
    return data.response.data;
  }
};

export const getCarnivalDataForUpdation = (carnivalId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getCarnivalData}?carnival_id=${carnivalId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CARNIVAL_DATA, payload: data.response.data });
    return data.response.data;
  }
};

export const createDuplicateCarnival = (requestData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.createDuplicateCarnival
  );
  if (res?.data?.response?.status === true) {
        return res?.data?.response;
  } else return false;
};

export const updateCarnivalData = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.updateCarnivalData
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const updateNormalOnboardingData = (requestData) => async () => {
  const res = await callWebService(
      callTypes.post,
      requestData,
      Config.brandActivation.updateNormalCarnival
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const getNormalOnboarding = (id) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.getNormalCarnival}?id=${id}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: NORMAL_ONBAORDING_DATA, payload: data.response.data });
    return data.response.data;
  }
};

export const getProjectOnboardingListing = (queryObj, page = 1) => async (dispatch) => {
  dispatch({ type: PROJECT_ONBOARDING_LISTING, payload: null });
  let filterQuery = `page=${page}`;
  if(queryObj !== null){
    filterQuery+= `&lead_type=${queryObj.lead_type}&lead_id=${queryObj.leadID}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate}&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&project_status=${queryObj.project_status}`;
  }

  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.getprojectOnboardingList}?${filterQuery}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: PROJECT_ONBOARDING_LISTING, payload: data.response.data });
    return data.response.data;
  }
};
export const getprojectOnboardingListForFinance = (queryObj, page = 1) => async (dispatch) => {
  dispatch({ type: PROJECT_ONBOARDING_LISTING, payload: null });
  let filterQuery = `page=${page}`;
  if(queryObj !== null){
    filterQuery+= `&lead_type=${queryObj.lead_type}&lead_id=${queryObj.leadID}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate}&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&project_status=${queryObj.project_status}`;
  }

  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.getprojectOnboardingListForFinance}?${filterQuery}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: PROJECT_ONBOARDING_LISTING, payload: data.response.data });
    return data.response.data;
  }
};

export const getHelpdeskList = (filterData = null, page = 1) => async (dispatch) => {

  let filterQuery = '';
  if (filterData !== null) {
    filterQuery = `?page=${page}`;
    if (filterData?.status) {
      filterQuery = filterQuery + `&status=${filterData.status}`;
    }
    if (filterData?.project_id) {
      filterQuery = filterQuery + `&project_id=${filterData.project_id}`;
    }
    if (filterData?.project_name) {
      filterQuery = filterQuery + `&project_name=${filterData.project_name}`;
    }
    if (filterData?.fromDate) {
      filterQuery = filterQuery + `&from_date=${filterData.fromDate}`;
    }
    if (filterData?.toDate) {
      filterQuery = filterQuery + `&to_date=${filterData.toDate}`;
    }

  } else {
    filterQuery = `?page=${page}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.helpdeskListing}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: HELPDESK_LIST, payload: data.response.data });
    return data.response.data;
  }
};

export const saveHelpdesk = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.saveHelpdesk
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const getHelpdeskDetail = (meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.viewHelpdesk}?carnival_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: HELPDESK_DETAIL, payload: data.response.data });
    return data.response.data;
  }
};

export const getHelpdeskDataForUpdation = (carnivalId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getHelpdeskData}?carnival_id=${carnivalId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: HELPDESK_DATA, payload: data.response.data });
    return data.response.data;
  }
};

export const updateHelpdeskData = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.updateHelpdeskData
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const createDuplicateHelpdesk = (requestData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.createDuplicateHelpdesk
  );
  if (res?.data?.response?.status === true) {
    return res?.data?.response;
  } else return false;
};